export default "__VITE_ASSET__D9a5Vx9P__"